import { useProjectStore } from '@stores/project';
import { useUserStore } from '@stores/user';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { updateUserPermissionList } from '@/modules/Permission';

interface RouteManagerProps {
  children: React.ReactNode;
}

/**
 * 路由管理器
 */
export default function RouteManager(props: RouteManagerProps) {
  const { children } = props;
  const { projectId } = useParams();
  const currentProject = useProjectStore(state => state.currentProjectDetail);
  const isLogin = useUserStore(state => state.isLogin);
  const id = projectId || currentProject?.id;

  useEffect(() => {
    if (!isLogin || !id) {
      return;
    }
    updateUserPermissionList(id);
  }, [id, isLogin]);

  return <>{children}</>;
}
